import { render, staticRenderFns } from "./AddOrEditTask.vue?vue&type=template&id=3031d8b4&scoped=true&"
import script from "./AddOrEditTask.vue?vue&type=script&lang=js&"
export * from "./AddOrEditTask.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditTask.vue?vue&type=style&index=0&id=3031d8b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3031d8b4",
  null
  
)

export default component.exports